var refreshShareOptions = function(wth){
    if(wth.public.length > 0){
        //index
        $(".public-"+wth.report_uuid).html('<div class="text-muted d-flex justify-content-center text-center align-items-center w-100 h-100">'+wth.public+'</div>');
        $(".non-public-shares-"+wth.report_uuid).prop('disabled',false);
        $(".checkbox-"+wth.report_uuid).hide();
        $("#share-link-"+wth.report_uuid).show();
        //single
        $("#more-ways-to-share").fadeOut();
        $(".non-public-shares").prop("disabled", true);
        $("#share-link").show();
        $("#share-copy").attr("data-clipboard-text",wth.link);
        $("#shareable-link").attr("title",wth.link).html(wth["link-stub"]);
    }else{
        //index
        $(".public-"+wth.report_uuid).html('');
        $(".non-public-shares-"+wth.report_uuid).prop('disabled',false);
        $(".checkbox-"+wth.report_uuid).show();
        $("#share-link-"+wth.report_uuid).hide();
        //single
        $("#more-ways-to-share").fadeIn('slow');
        $(".non-public-shares").prop("disabled", false);
        $("#share-link").hide();
    }
    Do.Notify(wth);
}

$(document).ready( function() {

    $(".share-public").on('change',function(){
        report_uuid = $(this).attr("report-uuid");
       Do.Ajax('/report/sharing',{
           "public": $(this).prop("checked"),
           "uuid": report_uuid
        });
    });

    $(".my-personal-team").on('change',function(){
        report_uuid = $(this).attr("report-uuid");
        Do.Ajax('/report/sharing',{
           "mypersonal": $(this).prop("checked"),
           "uuid": report_uuid
        });
    });

    $(".offerer-team").on('change',function(){
        report_uuid = $(this).attr("report-uuid");
        Do.Ajax('/report/sharing',{
            "offerer": $(this).prop("checked"),
            "report": report_uuid,
            "team": $(this).attr("id"),
        });
    });

    $(".share-other").on('change',function(){
        report_uuid = $(this).attr("report-uuid");
        Do.Ajax('/report/sharing',{
           "other": $(this).prop("checked"),
           "report": report_uuid,
           "team": $(this).attr("id"),
        });
    });

    $("#share-copy").on('click', function(){
        var clip = new ClipboardJS("#share-copy");
        clip.on('success',function(e){
            $("#public-link-copied").show();
            $("#public-link-copied").fadeOut(3000);
            e.clearSelection();
        });
    });

});
